import React, { useEffect, useState } from 'react';
import Button from '../../../component/ui/Button';
import { useNavigate } from 'react-router-dom';
import Table from '../../../component/table/Table';
import sortbydot from '../../../assets/image/sort_by_group.svg';
import dateRange from '../../../assets/image/date_range.svg';
import moment from 'moment';
import Modal from '../../../component/modal/Modal';
import CustumDateSelect from './CustumDateSelect';
import Pagination from '../../../component/pagination';
import { fetchInventoryAdjustmentList } from '../../../services/adjustments';
import { getDate } from '../../../utils/dateUtils';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../utils/controller';

const InventoryAdjustment = () => {
	const suburl = localStorage.getItem('suburl');
	const [customDate, setCustomDate] = useState({ fromDate: null, toDate: null });
	const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
	const [showCustomDate, setShowCustomDate] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [headerDropDown, setHeaderDropDown] = useState('All');
	const [filterparam, setFilterparam] = useState();
	const [customDates, setCustomDates] = useState({
		startDate: new Date(),
		endDate: new Date(),
		key: 'selection',
	});
	const [sortDirection, setSortDirection] = useState({});
	const [sortParam, setSortParam] = useState({
		orderBy: 'created_at',
		sortBy: 'desc',
	});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [inventoryAdjustMentList, setInventoryAdjustMentList] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const pageSize = 20;

	const navigateRouter = (path) => {
		navigate(path);
	};

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const inventoryAdjustmentTableColoum = [
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'date' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								Date
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'ACCOUNT',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'account' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								ACCOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.account]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'DESCRIPTON',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'description' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DESCRIPTON
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.description]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'status' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'REFERENCE NUMBER',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'reference_number' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REFERENCE NUMBER
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.reference_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'REASON',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'reason' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REASON
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.reason]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CREATED TIME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortData({ sortBy: 'asc', orderBy: 'created_at' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CREATED TIME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.created_at]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	const onRowClick = (id) => {
		if (id && hasPermission('inventory.adjustments.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/inventory-adjustment-crete/${id}`);
		}
	};

	const getDateRange = (filter) => {
		const today = moment().startOf('day');
		let fromDate, toDate;
		switch (filter) {
			case 'Today':
				fromDate = today;
				toDate = moment(fromDate).endOf('day');
				break;
			case 'week':
				fromDate = moment(today).startOf('isoWeek');
				toDate = moment(today).endOf('isoWeek');
				break;
			case 'month':
				fromDate = moment(today).startOf('month');
				toDate = moment(today).endOf('month');
				break;
			case 'quarter':
				fromDate = moment(today).startOf('quarter');
				toDate = moment(today).endOf('quarter');
				break;
			case 'year':
				fromDate = moment(today).startOf('year');
				toDate = moment(today).endOf('year');
				break;
			case 'fiscal':
				fromDate =
					moment(today).month() >= 3
						? moment(today).startOf('year').month(3).startOf('month')
						: moment(today).subtract(1, 'year').month(3).startOf('month');
				toDate = moment(fromDate).add(1, 'year').subtract(1, 'day');
				break;
			case 'custom':
				fromDate = customDates.startDate;
				toDate = customDates.endDate;
				break;
			default:
				fromDate = null;
				toDate = null;
				break;
		}

		return {
			fromDate: fromDate ? fromDate.format('YYYY-MM-DD') : null,
			toDate: toDate ? toDate.format('YYYY-MM-DD') : null,
		};
	};

	const filterData = (filter, data) => {
		setHeaderDropDown(data);
		setSortParam('');
		if (filter === 'custum') {
			setShowCustomDate(true);
		} else {
			const { fromDate, toDate } = getDateRange(filter);
			let param = {
				filterValue: {
					startDate: fromDate,
					endDate: toDate,
				},
				filterBy: 'date',
			};
			setFilterparam(param);
			setShowCustomDate(false);
		}
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};
	const sortData = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		const paramData = {
			orderBy: param.orderBy,
			sortBy: newDirection,
		};
		setSortParam(paramData);
	};

	const getInventoryDetails = async () => {
		try {
			setLoading(true);
			let param = {
				...filterparam,
				...sortParam,
				page: currentPage,
				pageSize: pageSize,
			};
			const res = await fetchInventoryAdjustmentList(param);
			if (res?.success) {
				const inventoryList = res?.data?.data;
				let Tdata = [];
				let FilterData = inventoryList?.inventoryAdjustment?.filter((item) => {
					return item?.is_deleted === 0 && item?.is_draft !== 2;
				});
				FilterData?.map((data) => {
					Tdata?.push({
						id: data?.adjustment_id,
						DATE: getDate(data?.date),
						REASON: data?.reason?.reason_description,
						DESCRIPTON: data?.description,
						STATUS: data?.is_draft === 0 ? 'Draft' : 'Converted',
						'REFERENCE NUMBER': data?.reference_number,
						ACCOUNT: data?.account?.account_name,
						'CREATED TIME': getDate(data?.created_at),
					});
				});

				setTableData(Tdata);
				setTotalPages(res.data.data.totalPages || 1);
				setInventoryAdjustMentList(inventoryList);
			} else {
				setTableData([]);
				setTotalPages(0);
				setInventoryAdjustMentList([]);
			}
		} catch (err) {
			setTableData([]);
			setTotalPages(0);
			setInventoryAdjustMentList([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getInventoryDetails();
	}, [sortParam, filterparam, currentPage]);

	return (
		<div style={{ overflow: 'auto' }}>
			<div className="product-pg-header add-product">
				<div className="d-flex align-items-center gap-4">
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('', 'All')}
								>
									All
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('Today', 'Today')}
								>
									Today
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('week', 'This Week')}
								>
									This Week
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('month', 'This Month')}
								>
									This Month
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('quarter', 'This Quarter')}
								>
									This Quarter
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('year', 'This Year')}
								>
									This Year
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('fiscal', 'This Fiscal Year')}
								>
									This Fiscal Year
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('custum', 'Custom Date')}
								>
									Custom Date
								</a>
							</li>
						</ul>
						{showCustomDatePicker && (
							<div>
								<Modal
									className="custom-date-model"
									isOpen={showCustomDatePicker}
									onClose={() => setShowCustomDatePicker(false)}
									title="Select Custom Date"
								>
									<CustumDateSelect
										isOpen={showCustomDatePicker}
										onCLose={() => setShowCustomDatePicker(false)}
										reloadTable={''}
										setFilterparam={setFilterparam}
										setCustomDates={setCustomDates}
										customDates={customDates}
									/>
								</Modal>
							</div>
						)}
					</div>
					{showCustomDate && (
						<button
							onClick={() => setShowCustomDatePicker(!showCustomDatePicker)}
							style={{
								padding: '5px 10px',
								borderRadius: '6px',
								border: '1px solid #ccc',
								backgroundColor: '#f9f9f9',
								cursor: 'pointer',
							}}
							className="mx-2"
						>
							<div>
								<img
									src={dateRange}
									alt="Date"
									width={20}
									height={20}
								/>
								<span className="text-dark mx-4">
									{customDates.startDate !== null && customDates.endDate !== null
										? `${getDate(customDates.startDate)} - ${getDate(customDates.endDate)}`
										: 'Select Custom Date'}
								</span>
							</div>
						</button>
					)}
				</div>

				<div className="add-product-button column-gap-0">
					<Button
						type="button"
						className="btn-primary mt-0 px-5"
						button="Create New Adjustment"
						disabled={!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)}
						add
						onClick={() => navigateRouter(`/user/${suburl}/inventory-adjustment-crete`)}
					/>
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={sortbydot} />
						</a>
						{/* date , reason, created_at , description,status,reference_number, */}
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a className="dropdown-item sortBy">Sort By</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'date' })}
								>
									Date
									<span>{sortIconMap[sortDirection?.date]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'reason' })}
								>
									Reason
									<span>{sortIconMap[sortDirection?.reason]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'created_at' })}
								>
									Created Time
									<span>{sortIconMap[sortDirection?.created_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'description' })}
								>
									Description
									<span>{sortIconMap[sortDirection?.description]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'status' })}
								>
									Status
									<span>{sortIconMap[sortDirection?.status]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'reference_number' })}
								>
									Reference Number
									<span>{sortIconMap[sortDirection?.reference_number]}</span>
								</a>
							</li>
							{/* <li><a className="dropdown-item" onClick={() => sortData(`orderBy=reason&sortBy=asc`)}>Created By</a></li> */}
							{/* <li><a className="dropdown-item" onClick={() => sortData(`orderBy=reason&sortBy=asc`)}>Created Time</a></li> */}
						</ul>
					</div>
				</div>
			</div>

			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : (
				<div className="productTable-body">
					<Table
						row={tableData}
						coloum={inventoryAdjustmentTableColoum}
						className="productTable"
						onRowClick={onRowClick}
					/>
				</div>
			)}
			<Pagination
				currentPage={currentPage}
				totalPages={totalPages}
				onChangePage={handlePageChange}
			/>
		</div>
	);
};

export default InventoryAdjustment;
